<template>
  <div class="projectContent">
    <!-- <div class="phead_box"></div> -->
    <div v-loading="isLoading" element-loading-text="加载中，请稍候..." element-loading-spinner-color="#56B275"
      element-loading-background="rgba(255, 255, 255, 0.8)" style="position: relative; min-height: 100vh;">

      <div>
        <el-card class="mart10">
          <div class="men">
            <el-row>
              <el-menu mode="horizontal" class="menu" active-text-color=" #56B275" :default-active="activeIndex">
                <el-menu-item class="it" style="font-size: 20px;" :key="index" v-for="(item, index) in menuList"
                  :index="index" @click="pathto(item)">
                  {{ item.name }}
                </el-menu-item>
              </el-menu>
            </el-row>
          </div>
        </el-card>
      </div>
      <div style="display: flex;flex-direction: row;justify-content: center;flex-wrap: wrap;padding:0 3vw;gap: 20px;">
        <div v-for="(product, index) in projectData" :key="index" class="product_card"
          v-memo="[product.viewpic, product.name]">
          <div>
            <p style=" border-left: 1vw solid #56B275;font-size: 1.1vw;padding-left: 1vw;height: 2vw;white-space: nowrap;"
              :style="{ marginBottom: $i18n.locale === 'en' ? '30px' : '' }">
              {{ product.name }}
            </p>
            <div class="product_p1"></div>
            <div class="product_p2"></div>
            <!-- <img :src="product.viewpic" :alt="product.title" style="width: 13vw;height: 18vw;"> -->
            <el-image :src="preview(product.viewpic)" lazy id="pp" style="width: 15vw;height: 18vw;"></el-image>
            <div @click="gotoDetail(product)" class="product_btn">
              点击查看</div>
          </div>
        </div>
      </div>
      <div class="pagespagin">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
          :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" color="#56B275">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getProduct, getSeries } from "@/api";

import { type } from "jquery";
import $ from 'jquery';
export default {
  data() {
    return {
      pageSize: 10,
      menuList: [
        { name: '立式' }
      ],
      activeIndex: 0,
      projectData: [],
      allProjectData: [],
      page: 1,
      total: 0,
      isLoading: false
    };
  },

  computed: {
  },
  // uodated() {
  //   Vue.set(this.data, "inner", {
  //     ...this.data.inner,
  //     key: "new value",
  //   });
  // },
  mounted() {
    // this.$store.state.count='25'
    // this.menuList = [
    //   { name: this.$t("user.productst1"), id: 'quanbu' },
    //   { name: this.$t("user.productst2"), id: 'jiaoyu' },
    //   { name: this.$t("user.productst3"), id: 'yiliao' },
    //   { name: this.$t("user.productst4"), id: 'dianshan' },
    //   { name: this.$t("user.productst5"), id: 'fangdichan' },
    //   { name: this.$t("user.productst6"), id: 'gaosu' },
    //   // { name: '社交', id: 'shejiao' },
    // ],
    this.getSeries()
      .then(() => {
        // 获取分类后，请求全量产品数据
        return this.getAllProductData();
      })
      .then(() => {
        // 全量数据拿到后，执行分页（渲染第 1 页）
        this.handlePagination();
      });

  },
  methods: {
    gotoDetail(product) {
      this.$router.push({
        name: 'frProjectDetail',
        params: product
      });
    },
    preview(url) {
      console.log(2222)
      // setTimeout(() => {
      return url;
      // }, 1000);
    },
    getSeries() {
      // 返回Promise以便后续处理
      return getSeries().then((res) => {
        // 先清空原有列表，再添加"全部"选项和接口返回的数据
        this.menuList = [{ name: '全部' }, ...res.data];
        // 设置默认选中项为"全部"
        this.activeIndex = '0';
        return Promise.resolve();
      });
    },
    toPages(projectId) {
      this.$router.push({ path: "frProductDetail/" + projectId });
    },
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页条数
      this.page = 1; // 重置为第1页
      this.handlePagination(); // 重新请求数据（用当前选中的菜单）
    },

    // 处理页码变化（当点击页码或上一页/下一页时触发）
    handleCurrentChange(val) {
      this.page = val; // 更新当前页码
      this.handlePagination();// 重新请求数据
    },
    getAllProductData(item) {
      this.isLoading = true;
      const params = {
        page: 1,
        pageSize: 99999, // 用极大值确保拿到全部数据（或后端支持传 0 取全部）
      };
      // 根据实际需求，若菜单筛选需传 type，这里也加上（比如默认全部时可不传）
      if (item && item.name !== '全部') {
        params.type = item.name;
      }
      return getProduct(params).then((res) => {
        // 存全量数据 + 排序
        this.allProjectData = res.data.sort((a, b) => {
          return parseInt(b.sort, 10) - parseInt(a.sort, 10);
        });
        this.total = this.allProjectData.length; // 总条数 = 全量数据长度
        this.isLoading = false;
        return Promise.resolve();
      }).catch((err) => {
        console.error('获取全量产品数据失败:', err);
        this.isLoading = false;
        return Promise.reject(err);
      });
    },
    pathto(item) {
      if (item && item.name) {
        this.getAllProductData(item).then(() => {
          this.page = 1; // 重置页码
          this.handlePagination(); // 重新分页
        });
      }


      // this.page = 1;
      // this.isLoading = true;
      // const params = {
      //   page: this.page,
      //   pageSize: this.pageSize
      // };

      // // 只有当 item?.name 存在时，才添加 type 参数
      // if (item && item.name && item.name !== '全部') {
      //   params.type = item.name;
      // }
      // getProduct(params).then((res) => {
      //   // this.projectData = res.data; // 简化数组赋值
      //   console.log('排序前', this.projectData)
      //   // this.projectData = this.projectData.sort((a, b) => {
      //   //   const numA = parseInt(a.sort, 10);
      //   //   const numB = parseInt(b.sort, 10);
      //   //   return numB - numA;
      //   // });
      //   // this.$forceUpdate();
      //   // console.log('排序后', this.projectData)
      //   // this.total = Number(res.headers['x-total-count'] || 0);
      //   // this.isLoading = false;
      //   this.allProjectData = res.data.sort((a, b) => {
      //     return parseInt(b.sort, 10) - parseInt(a.sort, 10);
      //   });
      //   this.total = this.allProjectData.length; // 总条数 = 全量数据长度
      //   this.isLoading = false;
      //   return Promise.resolve();
      // }).catch((err) => {
      //   console.error('获取产品数据失败:', err);
      //   this.isLoading = false; // 请求失败，也设置为加载结束
      // });
    }, // 【新增】处理分页逻辑：从 allProjectData 截取当前页数据
    handlePagination() {
      const start = (this.page - 1) * this.pageSize;
      const end = start + this.pageSize;
      // 截取当前页数据
      this.projectData = this.allProjectData.slice(start, end);
      this.$forceUpdate(); // 强制更新（若数据不渲染可加）
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-loading-spinner .circular .path {
  stroke: #56B275 !important;
  /* 圈圈的边框颜色 */
}

/* 若加载文字也需要改颜色，可添加以下代码 */
/deep/ .el-loading-text {
  color: #56B275 !important;
  /* 加载文字颜色 */
}

@media (max-width: 768px) {
  .phead_box {
    height: 270px !important;
  }
}

.product_card {
  height: 28vw;
  // height: 500px;
  border: 1px solid #F4F4F4;
  width: 17vw;
  // width: 300px;
  margin-top: 50px;
  padding-left: 30px;
  padding-top:
    30px;
  border-radius: 50px;
  padding-right: 30px;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  padding-bottom: 10px;
}

.product_card:hover .product_btn {
  // color: pink;
  transform: scale(1.2);
  background-color: #56B275;
  color: white;
}

.product_card:hover {
  // color: pink;
  transform: scale(1.1);
  // background-color: #1A96D2;
  // color: white;
}

.product_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background-color: #f1f1f1;
  width: 6vw;
  height: 2vw;
  // color: #f3f3f3;
  margin: auto;
  margin-top: 1vw;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.projectContent {
  width: 100%;
  margin-top: 130px;

  //.phead_box {
  //width: 100%;
  //height: 520px;
  //background: url(../assets/furuiImg/probanner.webp) no-repeat;
  //background-size: cover;
  //background-position: center;
  //}
}

.men {
  // width: 1000px;
  height: 60px;
  // border: 1px solid black;
  margin: auto;
  text-align: center;
  display: flex;
  justify-content: center;
}

.it {
  // padding-left: 100px;
  color: #888888;
  font-weight: bold;
  border-color: #56B275;
  text-align: center;

}


.xq {
  margin-left: 100px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 100px;
  // justify-content: space-evenly;
  gap: 100px;
  //height: 140px;
  // border: 1px solid black;
  // background-image: url("../../../官网pc端/关于我们/7提交需求.jpg");
  // background-size: 100% 100%;
}

#overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */

}

/deep/.el-pager li.active {
  color: #56B275 !important;
}

/deep/.el-pager li.active:hover {
  color: #56B275 !important;
}

/deep/.el-menu-item {
  padding-left: 50px;
  padding-right: 50px;
}

/deep/.el-menu-item.it {
  border: transparent;
}

/deep/.el-menu-item.is-active {

  color: #56B275;
  border-color: #56B275;
  font-size: 20px;
  border: 2px solid;
  border-color: #56B275;
  font-size: 20px;
  border: 2px solid;
  border-radius: 28px;
  border-bottom-color: unset !important;
}

// /deep/.el-menu--horizontal>.el-menu-item {
//   background-color: unset  !important;
// }
// img {
//       image-rendering: pixelated;
// }
img {

  image-rendering: -webkit-optimize-contrast;

}

.project_content {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 80px;
}

.project_item {
  width: 300px;
  height: auto;
  display: flex;
  flex-direction: column;
}

.project_item img {
  width: 300px;
  height: auto;
}

.pagespagin {
  // margin-top: 40px;
  margin: 40px 0;
  text-align: center;
}

.product_p1 {
  height: 2px;
  background-color: #56B275;
  width: 100%;
  margin-top: 10px;
}

.product_p2 {
  height: 4px;
  background-color: #56B275;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 3px;
}
</style>